import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
import Text from '@common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import Icon from '@common/assets';
import Image from '@common/image';
import Link from 'next/link';
import { MatchRouteUrl } from '@utils/routeUtil';

const cx = classnames.bind(styles);

const Banner = () => {
  return (
    <Link href={MatchRouteUrl.MATCH_INTRODUCE}>
      <div className={cx('bannerArea')}>
        <ul className={cx('logoList')}>
          <li className={cx('logoImg')} aria-label="logo" />
          <li className={cx('logoImg')} aria-label="logo" />
          <li className={cx('logoImg')} aria-label="logo" />
        </ul>

        <Image
          src={'/img/v2/components/acca/test/imgPhone.png'}
          className={cx('img')}
          width={160}
          height={150}
          alt={'알림톡 도착'}
        />

        <div className={cx('textArea')}>
          <Text fontStyle={FontStyle.H5_B} color={Colors.C_JOBDA_BLACK}>
            이제, 스펙과 자소서가 아닌
            <br />
            ‘역량’만으로 입사 제안 받으세요.
          </Text>
          <Text className={cx('link')} fontStyle={FontStyle.B4_M} color={Colors.C_COOL_GRAY_80}>
            JOBDA matching 자세히 보기
            <Icon name={'arrowRightLight'} width={24} height={24} fill={Colors.C_COOL_GRAY_80} />
          </Text>
        </div>
      </div>
    </Link>
  );
};

export default Banner;
